import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-concrete-950 py-16 sm:py-20" aria-labelledby="garantia" data-id="element-90" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-4xl flex-col gap-5 border border-concrete-700 bg-concrete-900 p-6 sm:flex-row sm:items-start sm:gap-8 sm:p-12" data-id="element-91" data-mp="223ekniyd552e">
        <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-safety text-safety-ink" aria-hidden="true" data-id="element-92" data-mp="1x4uz3jnolvak">
          <ShieldCheckIcon className="h-9 w-9" data-id="element-93" data-mp="14g63u19b4k6q" />
        </span>
        <div data-id="element-94" data-mp="14dteh317z7jn">
          <h2 id="garantia" className="font-display text-2xl uppercase leading-tight text-concrete-50 sm:text-4xl" data-id="element-95" data-mp="1j4ka6m5xmqs1">
            Garantía de satisfacción total 🤝
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-concrete-200" data-id="element-96" data-mp="qnpyuuwuic36">
            Si en 7 días sientes que este contenido no vale 10 veces lo que
            pagaste, te devuelvo tu dinero. Sin preguntas, sin resentimientos.
          </p>
          <p className="mt-3 font-display text-lg uppercase text-safety" data-id="element-97" data-mp="oz03pw3z42ou">
            Mi palabra de constructor.
          </p>
        </div>
      </div>
    </section>;
}